/**
 *  ACCOUNT
 *
 *  - Order details
 */

if (cube.$id('order-detail-page')) {
  require('./order/order').init();
  require('./order/myInvoice').init();
}

if (cube.$id('my-purchase') || cube.$id('account')) {
  require('./order/osmoseModal').init();
}

if (cube.$id('confirmation-container'))
  require('./order/dhlLinkCharacter.js').init();

if (cube.$('.reex-return-detail'))
  require('./returns/returns').init();




// WEBPACK FOOTER //
// ./src/modules-es5/account/index.js